import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { RenderForm } from "@components/Forms/Render";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function LandingCTItemEditScreen() {
    const { t } = useTranslation();
    const { slug, block_id, item_id } = useParams();
    const navigate = useNavigate();
    const apiUrl = url_reverse("api:landing_ct:block_items:crud", { block_id, item_id });
    const { apiData, setApiData } = useAppApi(apiUrl);
    const backUrl = url_reverse("admin:landing_ct:block_items", { slug, block_id });

    if (!apiData) return null;

    const header = (
        <>
            <Link to={url_reverse("admin:pockets:list")}>{t("Карманы")}</Link>
            <span> – </span>
            <Link to={url_reverse("admin:landing_ct:landings")}>{apiData.landing_name || t("Лендинги")}</Link>
            <span> – </span>
            <Link to={url_reverse("admin:landing_ct:landing_items", { slug })}>
                {apiData.landing_name || t("Лендинг")}
            </Link>
            <span> – </span>
            <Link to={backUrl}>{apiData.block_label || t("Блок")}</Link>
            <span> – </span>
            {t("Элемент")}
        </>
    );

    return (
        <DefaultLayout>
            <ListingCard header={header}>
                <RenderForm
                    apiData={apiData}
                    setApiData={setApiData}
                    afterRespOK={() => {
                        navigate(backUrl);
                    }}
                />
            </ListingCard>
        </DefaultLayout>
    );
}
